import { render } from "./WidgetTyping.vue?vue&type=template&id=38e9271d&scoped=true"
import script from "./WidgetTyping.vue?vue&type=script&lang=js"
export * from "./WidgetTyping.vue?vue&type=script&lang=js"

import "./WidgetTyping.vue?vue&type=style&index=0&id=38e9271d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e9271d"]])

export default __exports__